// Use turbolinks:load for Turbolinks compatibility
document.addEventListener('turbolinks:load', initFinalStatementLines);

function initFinalStatementLines() {
  const container = document.getElementById('lines-container');
  if (!container) return;

  const linesContainer = document.getElementById('final-statement-lines');
  const addButton = document.getElementById('add-line');
  const template = document.getElementById('line-template');

  if (!addButton || !template || !linesContainer) return;

  // Remove old event listeners by cloning
  const newAddButton = addButton.cloneNode(true);
  addButton.parentNode.replaceChild(newAddButton, addButton);

  // Add new line
  newAddButton.addEventListener('click', function(e) {
    e.preventDefault();
    const newIndex = new Date().getTime();
    const templateContent = template.innerHTML.replace(/NEW_RECORD/g, newIndex);

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = templateContent;
    const newFields = tempDiv.firstElementChild;

    linesContainer.appendChild(newFields);

    // Setup remove button for new line
    setupRemoveButton(newFields);
  });

  // Setup remove buttons for existing lines
  document.querySelectorAll('.nested-fields').forEach(function(fields) {
    setupRemoveButton(fields);
  });
}

function setupRemoveButton(fieldsElement) {
  const removeButton = fieldsElement.querySelector('.remove-line');
  if (!removeButton) return;

  // Remove old listeners by cloning
  const newRemoveButton = removeButton.cloneNode(true);
  removeButton.parentNode.replaceChild(newRemoveButton, removeButton);

  newRemoveButton.addEventListener('click', function(e) {
    e.preventDefault();
    const isNewRecord = fieldsElement.dataset.newRecord === 'true';

    if (isNewRecord) {
      // New record - just remove from DOM
      fieldsElement.remove();
    } else {
      // Existing record - mark for destruction and hide
      const destroyField = fieldsElement.querySelector('.destroy-field');
      if (destroyField) {
        destroyField.value = '1';
      }
      fieldsElement.style.display = 'none';
    }
  });
}
